import defaultHtmlSerializer from 'storyblok-js-client/source/schema.js';

export const LoadingImageUrl = 'https://a.storyblok.com/f/159374/267x150/f2782ab084/loading.svg';
export const WEB_APP_EN_SIGN_UP_URL = 'https://app.notta.ai/signup?language=en&from=official';
export const WEB_APP_JP_SIGN_UP_URL = 'https://app.notta.ai/signup?language=jp&from=official';
export const WEB_APP_EN_LOGIN_IN_URL = 'https://app.notta.ai/login?language=en&from=official';
export const WEB_APP_JP_LOGIN_IN_URL = 'https://app.notta.ai/login?language=jp&from=official';

export interface IImageProp {
  src: string;
  alt: string;
}

export type ButtonType = 'default' | 'primary' | 'link';

export interface ICmsRichText {
  type: 'doc';
  content: Array<object>;
}
export interface ICMSAsset {
  id: number;
  alt: string;
  name: string;
  focus: string;
  title: string;
  filename: string;
  copyright: string;
  fieldtype: string;
  is_external_url: boolean;
}

export const isEmailLinkType = (type) => type === 'email';

export const richTextSchema = {
  ...Object.assign(defaultHtmlSerializer, {
    marks: {
      ...Object.assign(defaultHtmlSerializer.marks, {
        link(node) {
          const attrs = { ...node.attrs };
          const { linktype = 'url' } = node.attrs;

          if (isEmailLinkType(linktype)) {
            attrs.href = `mailto:${attrs.href}`;
          }

          if (attrs.anchor) {
            attrs.href = `${attrs.href}#${attrs.anchor}`;
            delete attrs.anchor;
          }

          if (attrs.custom) {
            for (const key in attrs.custom) {
              attrs[key] = attrs.custom[key];
            }
            delete attrs.custom;
          }

          return {
            tag: [
              {
                tag: 'a',
                attrs: attrs,
              },
            ],
          };
        },
      }),
    },
  }),
};

export const HONOR_LOGOS: IImageProp[] = [
  {
    src: 'https://a.storyblok.com/f/159374/286x60/54bba3e737/01.svg',
    alt: '作業効率改善に最適AI文字起こしサービス',
  },
  {
    src: 'https://a.storyblok.com/f/159374/266x60/f6342a232c/02.svg',
    alt: 'データの安全性で選びたいAI文字起こしサービス',
  },
  {
    src: 'https://a.storyblok.com/f/159374/276x60/b91de5789b/03.svg',
    alt: '経営者がおすすめするAI文字起こしサービス',
  },
];

export const HONOR_LOGOS_WITH_NUMBER: IImageProp[] = [
  {
    src: 'https://a.storyblok.com/f/159374/286x60/41d0079c56/1.svg',
    alt: '作業効率改善に最適AI文字起こしサービス',
  },
  {
    src: 'https://a.storyblok.com/f/159374/267x60/19e4bd7621/2.svg',
    alt: 'データの安全性で選びたいAI文字起こしサービス',
  },
  {
    src: 'https://a.storyblok.com/f/159374/279x60/2aabaaf0d3/3.svg',
    alt: '経営者がおすすめするAI文字起こしサービス',
  },
];

export const HOST_URL = 'https://www.notta.ai';
